export type Category =
  | 'All'
  | 'LLMs & Foundation Models'
  | 'Voice AI'
  | 'Computer Vision'
  | 'Agentic AI'
  | 'RAG & Search'
  | 'Healthtech AI'
  | 'Fintech AI'
  | 'Devtools'
  | 'Robotics'
  | 'Edtech AI'
  | 'Legaltech AI'
  | 'Enterprise AI'
  | 'Consumer AI'
  | 'Logistics AI'
  | 'Retail AI'

export const CATEGORIES: Category[] = [
  'All',
  'LLMs & Foundation Models',
  'Voice AI',
  'Computer Vision',
  'Agentic AI',
  'RAG & Search',
  'Healthtech AI',
  'Fintech AI',
  'Devtools',
  'Robotics',
  'Edtech AI',
  'Legaltech AI',
]

export interface Startup {
  id: string
  name: string
  tagline: string
  category: Category
  location: string
  stage: string
  isFeatured?: boolean
  colorClass: string
}

export const STARTUPS: Startup[] = [
  {
    id: 'sarvam-ai',
    name: 'Sarvam AI',
    tagline:
      'Building full-stack generative AI for India, starting with Indic LLMs.',
    category: 'LLMs & Foundation Models',
    location: 'Bengaluru',
    stage: 'Series A',
    isFeatured: true,
    colorClass: 'bg-[#FF6B1A] text-white', // Saffron accent
  },
  {
    id: 'krutrim',
    name: 'Krutrim',
    tagline:
      "India's own AI model, trained on massive Indic language datasets.",
    category: 'LLMs & Foundation Models',
    location: 'Bengaluru',
    stage: 'Unicorn',
    isFeatured: true,
    colorClass: 'bg-neutral-900 text-white',
  },
  {
    id: 'yellow-ai',
    name: 'Yellow.ai',
    tagline:
      'Dynamic AI agents for enterprise customer and employee experience.',
    category: 'Agentic AI',
    location: 'Bengaluru',
    stage: 'Series C',
    isFeatured: true,
    colorClass: 'bg-yellow-500 text-white',
  },
  {
    id: 'haptik',
    name: 'Haptik',
    tagline:
      'Conversational AI platform powering intelligent virtual assistants.',
    category: 'Voice AI',
    location: 'Mumbai',
    stage: 'Acquired',
    colorClass: 'bg-blue-600 text-white',
  },
  {
    id: 'mad-street-den',
    name: 'Mad Street Den',
    tagline:
      'Enterprise AI platform bringing computer vision to retail and beyond.',
    category: 'Computer Vision',
    location: 'Chennai',
    stage: 'Series C',
    colorClass: 'bg-pink-600 text-white',
  },
  {
    id: 'niramai',
    name: 'Niramai',
    tagline: 'Non-invasive, AI-based breast cancer screening solution.',
    category: 'Healthtech AI',
    location: 'Bengaluru',
    stage: 'Series B',
    colorClass: 'bg-teal-600 text-white',
  },
  {
    id: 'sigtuple',
    name: 'SigTuple',
    tagline: 'AI-powered digital pathology and diagnostic solutions.',
    category: 'Healthtech AI',
    location: 'Bengaluru',
    stage: 'Series C',
    colorClass: 'bg-indigo-600 text-white',
  },
  {
    id: 'observe-ai',
    name: 'Observe.AI',
    tagline:
      'Intelligent workforce platform for contact centers using voice AI.',
    category: 'Voice AI',
    location: 'Bengaluru',
    stage: 'Series C',
    colorClass: 'bg-neutral-800 text-white',
  },
  {
    id: 'uniphore',
    name: 'Uniphore',
    tagline: 'Enterprise conversational AI platform for customer service.',
    category: 'Voice AI',
    location: 'Chennai',
    stage: 'Series E',
    colorClass: 'bg-emerald-600 text-white',
  },
  {
    id: 'fractal',
    name: 'Fractal',
    tagline: 'Powering every human decision in the enterprise with AI.',
    category: 'Enterprise AI',
    location: 'Mumbai',
    stage: 'Unicorn',
    colorClass: 'bg-purple-600 text-white',
  },
  {
    id: 'glance-ai',
    name: 'Glance AI',
    tagline: 'AI-driven lock screen content discovery platform.',
    category: 'Consumer AI',
    location: 'Bengaluru',
    stage: 'Unicorn',
    colorClass: 'bg-green-500 text-white',
  },
  {
    id: 'corover-ai',
    name: 'CoRover.ai',
    tagline:
      'Human-centric conversational AI platform with video and voice bots.',
    category: 'Agentic AI',
    location: 'Bengaluru',
    stage: 'Series A',
    colorClass: 'bg-sky-600 text-white',
  },
  {
    id: 'gnani-ai',
    name: 'Gnani.ai',
    tagline:
      'Voice-first AI for omnichannel customer service in Indic languages.',
    category: 'Voice AI',
    location: 'Bengaluru',
    stage: 'Series A',
    colorClass: 'bg-orange-500 text-white',
  },
  {
    id: 'skit-ai',
    name: 'Skit.ai',
    tagline: 'Voice AI platform automating contact center operations.',
    category: 'Voice AI',
    location: 'Bengaluru',
    stage: 'Series B',
    colorClass: 'bg-neutral-700 text-white',
  },
  {
    id: 'avaamo',
    name: 'Avaamo',
    tagline:
      'Deep-learning software company specializing in conversational interfaces.',
    category: 'Voice AI',
    location: 'Bengaluru',
    stage: 'Series C',
    colorClass: 'bg-cyan-600 text-white',
  },
  {
    id: 'mihup',
    name: 'Mihup',
    tagline: 'Speech recognition platform for vernacular languages.',
    category: 'Voice AI',
    location: 'Kolkata',
    stage: 'Series A',
    colorClass: 'bg-rose-600 text-white',
  },
  {
    id: 'locus-sh',
    name: 'Locus.sh',
    tagline: 'AI-driven logistics decision-making platform.',
    category: 'Logistics AI',
    location: 'Bengaluru',
    stage: 'Series C',
    colorClass: 'bg-blue-800 text-white',
  },
  {
    id: 'vue-ai',
    name: 'Vue.ai',
    tagline:
      'End-to-end retail automation platform powered by computer vision.',
    category: 'Retail AI',
    location: 'Chennai',
    stage: 'Series C',
    colorClass: 'bg-fuchsia-600 text-white',
  },
]
